export default __webpack_public_path__ + "static/media/botanalytics.00b627be.svg";